// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3itL7","insightsList":"newBusinessInsightsMenu_insightsList__1cYuG","active":"newBusinessInsightsMenu_active__2Bt-K"};